import { Button, Dialog, DialogActions, DialogContent, TextField, DialogContentText, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import React, { useState } from 'react';
import { createTitle } from '../../utils/apiFunctions';

const NewTitle = ({ handleCloseDialog, openDialogNewTitle, openAlert, setEmployeeFields, setEmployeeFieldsToUpdate }) => {
    const [newTitle, setNewTitle] = useState('')
    const [isSaving, setIsSaving] = useState(false);

    const createNewTitle = async (newTitle) => {
        try {
            setIsSaving(true);
    
            const response = await createTitle(newTitle);
              
            if (response && response.status === 200) {
                setEmployeeFields(prev => ({
                    ...prev,
                    title: newTitle,
                    titleId: response.data.id
                }));
                setEmployeeFieldsToUpdate(prev => ({
                    ...prev,
                    title: {title: newTitle},
                    title_id: response.data.id
                }));
            }
    
            openAlert(response.message, response && response.status === 200 ? 'success' : 'error');
    
            handleCloseDialog();
        } catch (error) {
            console.error(error);
            openAlert('Failed to create title', 'error');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Dialog
            open={openDialogNewTitle}
            maxWidth='xl'
        >
            <DialogTitle>Add a new job title</DialogTitle>
                        <DialogContent>
                        <TextField
            autoFocus
            fullWidth
            label="Job title"
            placeholder="e.g. Senior Lifecycle Manager"
            helperText="Use proper capitalization. This will appear in the Directory."
            value={newTitle}
            sx={{ mt: 1 }}
            onChange={(e) => setNewTitle(e.target.value)}
            />

                <DialogActions>
                    <Button
                        onClick={handleCloseDialog}
                        // variant="contained"
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        loading={isSaving}
                        onClick={() => createNewTitle(newTitle)}
                        disabled={!newTitle?.trim() || isSaving}
                        variant="contained"
                    >
                        Confirm
                    </LoadingButton>

                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}

export default NewTitle